import React from "react";

function Instructions() {
  return (
    <div className="instructions">
      <p>
        1. Primero ingresa a netflix y pide codigo o pin de viaje, espera de 2 a 3 minutos.
      </p>
      <img 
        src="0.jpeg" 
        alt="Instrucciones Netflix" 
        style={{ width: "35%", height: "auto" }} 
       />
      <p>
        2. Ingresa el correo de tu cuenta en el campo de búsqueda y presiona "Buscar".
      </p>
      <p>
        3. Busca en el texto del correo el código o pin de viaje.
      </p>
    </div>
  );
}

export default Instructions;
